import "./Form_module.css";
const Form_module = {
    form: "form__cf1171140c4920f2",
    autoLayout: "autoLayout__cf1171140c4920f2"
};
export { Form_module as default };
